import {EzLandingsTrackerClient} from 'event_tracker';
import {DATA_TYPE} from 'event_tracker/constants';

const mapCheckboxValuesReducer = fields => {
  const fieldsValues = {};

  fields.forEach(field => {
    const key = field.name;

    if (key && field.checked) {
      if (fieldsValues[key]) {
        fieldsValues[key].push(field.value);
      } else {
        fieldsValues[key] = [field.value];
      }
    }
  });

  return fieldsValues;
};

const mapSingleFieldValuesReducer = fields => {
  const fieldsValues = {};

  fields.forEach(field => {
    if (field.name && field[field.type === 'radio' ? 'checked' : 'value']) {
      fieldsValues[field.name] = field.value;
    }
  });

  return fieldsValues;
};

const getFormInputsValues = form => {
  const singleValueFields = form.querySelectorAll(
    'input[type=text], input[type=email], input[type=tel], input[type=hidden], input[type=range], input[type=radio], select',
  );
  const checkboxFields = form.querySelectorAll('input[type=checkbox]');

  return JSON.stringify({
    ...mapSingleFieldValuesReducer(singleValueFields),
    ...mapCheckboxValuesReducer(checkboxFields),
  });
};

// Handles response timeout for slower devices. If event tracker response takes longer than
// 2.5 seconds it will submit the form and not track the event.
const onFormSubmit = formElement => {
  const submitForm = () => {
    if (
      formElement.dataset.form &&
      formElement.dataset.formState !== 'error' &&
      formElement.dataset.formState !== 'processing' &&
      formElement.dataset.formState !== 'processing_error' &&
      formElement.dataset.formAutoSubmit !== 'false'
    ) {
      formElement.submit();
    }
  };

  Promise.race([
    EzLandingsTrackerClient.trackSubmit({
      key: formElement.id,
      type: formElement.getAttribute(DATA_TYPE),
      value: getFormInputsValues(formElement),
    }),
    new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 2500)),
  ])
    .then(submitForm)
    .catch(error => {
      console.log('timeout', error);
      submitForm();
    });
};

export const setSubmitEventTracker = () =>
  document.querySelectorAll('form').forEach(formElement =>
    formElement.addEventListener('submit', event => {
      if (formElement.dataset.form) {
        event.preventDefault();
      }

      onFormSubmit(formElement);
    }),
  );
